import { EventMessage, IntegrationMessage, IntegrationResponseMessage } from '../types'

export function isMissingRawEvent(
  incomingMessage: EventMessage | IntegrationMessage | IntegrationResponseMessage
) {
  return incomingMessage.type === 'event' && !incomingMessage.rawEvent
}
